import { createRelayResource } from '@townsquare/relay-utils';

import TopicHeaderRefreshedQuery, {
	type TopicHeaderRefreshedQuery as TopicHeaderRefreshedQueryType,
} from '../ui/TopicHeaderRefreshed/__generated__/TopicHeaderRefreshedQuery.graphql';

export const topicViewHeaderResource = createRelayResource<TopicHeaderRefreshedQueryType>({
	getQuery: (routerContext) => {
		return {
			query: TopicHeaderRefreshedQuery,
			variables: {
				tagUuid: routerContext.match.params.uuid ?? '',
				trackViewEvent: 'DIRECT',
			},
		};
	},
});
